import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 titleWords text-2xl" }, "Your MILEZ ", -1)
const _hoisted_2 = { class: "mb-2 words" }
const _hoisted_3 = { class: "mb-2 words" }
const _hoisted_4 = { class: "mb-2 words" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2 words"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-2 words"
}
const _hoisted_7 = {
  key: 2,
  class: "mb-2 words"
}
const _hoisted_8 = {
  key: 3,
  class: "mb-2 words"
}
const _hoisted_9 = {
  key: 4,
  class: "mb-2 words"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, "Milez accrued: " + _toDisplayString(_ctx.reward.accruedReward/1000000), 1),
    _createElementVNode("div", _hoisted_3, "Milez paid: " + _toDisplayString(_ctx.reward.paidOutReward/1000000), 1),
    _createElementVNode("div", _hoisted_4, " Last updated: " + _toDisplayString(_ctx.parseDate(_ctx.reward.fixedRate.lastUpdatedTs)), 1),
    (_ctx.gems>19)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Accrual Rate: " + _toDisplayString(_ctx.rarities*1.25) + " MILEZ per Day", 1))
      : (_ctx.gems>9)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Accrual Rate: " + _toDisplayString(_ctx.rarities*1.2) + " MILEZ per Day", 1))
        : (_ctx.gems>4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Accrual Rate: " + _toDisplayString(_ctx.rarities*1.1) + " MILEZ per Day", 1))
          : (_ctx.gems>2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Accrual Rate: " + _toDisplayString(_ctx.rarities*1.05) + " MILEZ per Day", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, "Accrual Rate: " + _toDisplayString(_ctx.rarities) + " MILEZ per Day", 1))
  ], 64))
}